import React from 'react';
import axios from 'axios';
import Image from '../ui/Image';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import './Products.css';
import { useQuery } from '@tanstack/react-query';
import { ImageDownIcon } from 'lucide-react';
import { useLanguage } from '../../store/language-context';
import { useTranslation } from 'react-i18next';

const ClientsSection = () => {
  const { URL } = useLanguage();
  const { t } = useTranslation();

  const { data: clientsData = [], isLoading, error, refetch } = useQuery({
    queryKey: ['clients-slider', URL],
    queryFn: async () => {
      const response = await axios.get(`${URL}/clients?per_page=200`);
      if (response.data.status === 200) {
        return response?.data?.data?.data;
      } else {
        throw new Error(t('custom.err'));
      }
    },
    retry: 1,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 60 * 6, // 6HR
    gcTime: 1000 * 60 * 60 * 6,
  });


  return (
    <section className="w-full py-5 bg-white text-center">
      <div className="logo-slider-container">
        <div className="two-clients">
          <div className="clients-header col-lg-2 px-2">
            <p className="services-header after:w-16 after:-bottom-0.5 text-nowrap">
              {t('home.ivory-clients')}
            </p>
          </div>
          {
            isLoading ?
              <div className="grid grid-cols-4 gap-5 max-2xl:grid-cols-2 max-lg:grid-cols-1 w-full px-4">
                {[...Array(4)].map((_, i) => (
                  <div key={i} className={`l-load w-full h-32 rounded-lg justify-center items-center text-white ${(i === 0) ? 'flex' : 'flex max-lg:!hidden'}`}
                  >
                    <ImageDownIcon size={30} />
                  </div>
                ))}
              </div>
              :
              error ? (
                <div className="text-center py-8">
                  <p className="text-red-500">{t('custom.err')}</p>
                  <button
                    className="mt-2 bg-secondary-tw text-white px-4 py-2 rounded-md"
                    onClick={() => refetch && refetch()}
                  >
                    {t('custom.try-again')}
                  </button>
                </div>
              ) : (
                <Swiper
                  modules={[Navigation, Pagination, Autoplay]}
                  spaceBetween={20}
                  slidesPerView={4}
                  loop={true}
                  autoplay={{ delay: 3000, disableOnInteraction: false }}
                  breakpoints={{
                    300: { slidesPerView: 1, spaceBetween: 10 },
                    480: { slidesPerView: 2, spaceBetween: 15 },
                    768: { slidesPerView: 3, spaceBetween: 20 },
                    1024: { slidesPerView: 4, spaceBetween: 30 },
                  }}
                  className='!h-40'
                >
                  {clientsData?.map((client, i) => (
                    <SwiperSlide key={i} className='w-full h-36'>
                      <div className="relative flex justify-center items-center w-8/12 h-full">
                        <Image
                          src={client?.image}
                          alt={client?.name}
                          className="w-3/4 h-28 object-contain"
                        />
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              )}
        </div>
      </div>
    </section>
  );
};

export default ClientsSection;